// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"199":"4c1bff28","626":"bdf09a31","705":"4eac1c4d"}[chunkId] + ".css";
};